var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeLightBlueLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1842,
    height: 33,
    viewBox: "0 0 1842 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 33L1846 33V0L65 0V33Z",
    fill: "#1B7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 33H53L53 0H42V33Z",
    fill: "#1B7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 33H32L32 0H21L21 33Z",
    fill: "#1B7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 33H11L11 0H0L0 33Z",
    fill: "#1B7691"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeLightBlueLine);
export default __webpack_public_path__ + "static/media/resumeLightBlueLine.8d5682e87713affd6de3933b4d010234.svg";
export { ForwardRef as ReactComponent };